import { render, staticRenderFns } from "./ClaimPayment.vue?vue&type=template&id=598124dc&"
import script from "./ClaimPayment.vue?vue&type=script&lang=js&"
export * from "./ClaimPayment.vue?vue&type=script&lang=js&"
import style0 from "./ClaimPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports